module.exports = __webpack_public_path__ + "static/media/furvac360-2.db6652ed.jpg";